"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Meta = void 0;
/**
 * The metadata about a resource. This is content in the resource that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
 */
var Meta = /** @class */ (function () {
    function Meta() {
    }
    return Meta;
}());
exports.Meta = Meta;
